import {Component, Input, OnInit} from '@angular/core';
import {DialogService} from "@progress/kendo-angular-dialog";
import {CadPromocaoComponent} from "../cad-promocao/cad-promocao.component";
import {PromocoesService} from "../services/promocoes.service";
import {descrevaRegra, iconeDaRegra} from "../cad-promocao/regras-promocao";

const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];

@Component({
  selector: 'app-tela-promocoes',
  templateUrl: './tela-promocoes.component.html',
  styleUrls: ['./tela-promocoes.component.scss']
})
export class TelaPromocoesComponent implements OnInit {
  @Input() exibirTitulo = true;
  promocoes:  any = []
  carregando = false;
  modalDeletar: boolean;
  promocaoApagar: any;
  descrevaRegra = descrevaRegra;
  iconeDaRegra = iconeDaRegra;

  constructor(private dialogService: DialogService,
              private promocoesService: PromocoesService) { }

  ngOnInit(): void {
    this.carreguePromocoes()
  }

  editarPromocao(dataItem: any) {
    let copiaPromocao = Object.assign({}, dataItem)
    this.abraModalPromocao(copiaPromocao)
  }

  abraDialogRemover(promocao: any) {
    this.promocaoApagar = promocao;

    this.modalDeletar = true;
  }

  criarPromocao() {
    this.abraModalPromocao()
  }

  private abraModalPromocao(promocao: any = null) {
    let altura = window.innerHeight - 48;

    // Sem título: o cabeçalho e o rodapé são desenhados pelo próprio cadastro.
    const windowRef = this.dialogService.open({
      content: CadPromocaoComponent,
      cssClass: 'pm-dialogo-promocao',
      minWidth: 250,
      width: window.innerWidth > 992 ? 960 : window.innerWidth,
      maxHeight: altura
    });

    const telaPromocao: CadPromocaoComponent = windowRef.content.instance;

    telaPromocao.windowRef = windowRef;

    if(promocao && promocao.id)
      telaPromocao.promocao = promocao;

    windowRef.result.subscribe((result: any) => {
      if(result && result.id)
        this.carreguePromocoes();
    });
  }

  desativarPromocao(promocao: any) {
    promocao.ativa = false;
    this.promocoesService.desativePromocao(promocao).then( () => {

    }).catch( erro => {
      promocao.ativa = true;
      alert(erro)
    })



  }

  ativarPromocao(promocao: any) {
    promocao.ativa = true;
    this.promocoesService.ativePromocao(promocao).then( () => {

    }).catch( erro => {
      promocao.ativa = false;
      alert(erro)
    })

  }
  alterneAtiva(promocao: any) {
    if(promocao.ativa) this.desativarPromocao(promocao)
    else this.ativarPromocao(promocao)
  }

  statusDa(promocao: any): { id: string, rotulo: string } {
    if(!promocao.ativa) return { id: 'pausada', rotulo: 'Pausada' };

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    if(promocao.dataFim && new Date(promocao.dataFim) < hoje) return { id: 'encerrada', rotulo: 'Encerrada' };

    const amanha = new Date(hoje.getTime());
    amanha.setDate(amanha.getDate() + 1);

    if(promocao.dataInicio && new Date(promocao.dataInicio) >= amanha) return { id: 'agendada', rotulo: 'Agendada' };

    return { id: 'andamento', rotulo: 'Em andamento' };
  }

  primeirasRegras(promocao: any): any[] {
    return (promocao.regras || []).slice(0, 2);
  }

  diasDa(promocao: any): string {
    const dias = (promocao.horarios || []).map((horario: any) => horario.dia).sort();

    if(!dias.length || dias.length === 7) return 'Todos os dias';

    return dias.map((dia: number) => DIAS_SEMANA[dia]).join(', ');
  }

  close(cancel: string) {
    this.canceleRemocao()

  }

  confirmeRemocao() {
    let i = this.promocoes.indexOf(this.promocaoApagar);

    this.promocoesService.removaPromocao(this.promocaoApagar).then( () => {
      this.promocoes.splice(i, 1);
    }).catch( erro => {
      alert(erro)
    })

    this.canceleRemocao();

  }

  canceleRemocao() {
    this.modalDeletar = false;
    delete    this.promocaoApagar;

  }

  private carreguePromocoes() {
    this.carregando = true;
    this.promocoesService.listePromocoes({}).then( (resposta) => {
      this.carregando = false;
      this.promocoes = resposta;
    })
  }
}
